module.exports = __webpack_public_path__ + "img/accessory_shirt_02.edf5ea14.svg";